import axios from "../utils/axios";

export const getCurrentContext = async () => {
    const { data } = await axios.get('/current-context');
    return data;
};
